import React from 'react';
import ContactForm from './components/ContactForm'; // Adjust the path as necessary

function App() {
  return (
    <div className="App">
      <ContactForm />
    </div>
  );
}

export default App;
